import { CreateBrokenEngine } from "@pdfking/pdfengine"

import fail from "../utils/fail"

export const EngineCache = {}

export const Engine = CreateBrokenEngine()

export const CreateRemoteFile = fail
